import React, { Component } from "react";
import Select from "react-select";
import { Field, reduxForm, formValueSelector, change } from 'redux-form'
import moment from 'moment';

import { connect } from 'react-redux';
import { InputField } from '../../inputField';

import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { StartOfThisMonthDatePicker, DatePicker } from '../../datePicker';
import { Selection, DisabledSelection, SelectionWithProps } from '../../selection';

const changeDeliveryTime = (data, success, sales_order_id) => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/sale/sales_order/${sales_order_id}/dispatch_date`,
    data,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  })
    .then(res => {
      success();
    }, err => {
      console.log(err);
      // alert(err.statusText);
    })
}

// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222
const fetchAvaliablePickupTime = (date, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/mobile/pickup_time?pickup_date=${date}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  })
    .then(res => {
      console.log('res', res);
      success(res.data);
    }, err => {
      console.log(err);
      // alert(err.statusText);
    })
}


const modalStyle = {
  width: '350px',
  height: '150px',
  marginLeft: '-5%',
}

const propTypes = {
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
}

class form extends Component {
  renderUploadInputs = () => {
    return (
      <div>
        <input
          type="file"
          style={{ display: "none" }}
          onClick={(e) => { e.target.value = null }}
          onChange={(e) => {
            const formData = new FormData();
            formData.append("FILE", e.target.files[0]);
            if (e.target.files[0]) {
              axios
                .post(
                  `${ROOT_URL}v2/import_orders_tn`,
                  formData,
                  {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem(
                        "token"
                      )}`,
                    },
                  }
                )
                .then(
                  (res) => {
                    alert("SO Imported Successfully");
                    this.props.onSuccess();
                  },
                  (err) => {
                    if (err.data) {
                      alert(err.data);
                    } else {
                      alert("Server issue detected, please contact admin.");
                    }
                  }
                );
            }
          }}
          ref="msoCreateInputRef"
        />
        <input
          type="file"
          style={{ display: "none" }}
          onClick={(e) => { e.target.value = null }}
          onChange={(e) => {
            const formData = new FormData();
            formData.append("FILE", e.target.files[0]);
            if (e.target.files[0]) {
              axios
                .post(
                  `${ROOT_URL}v2/tn_order_import_original`,
                  formData,
                  {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem(
                        "token"
                      )}`,
                    },
                  }
                )
                .then(
                  (res) => {
                    alert("SO Imported Successfully");
                    this.props.onSuccess();
                  },
                  (err) => {
                    if (err.data) {
                      alert(err.data);
                    } else {
                      alert("Server issue detected, please contact admin.");
                    }
                  }
                );
            }
          }}
          ref="msoCreateInputRefOriginal"
        />
      </div>
    )
  }

  render() {
    const {
      handleSubmit
    } = this.props;
    return (
      <form style={{ width: '100%', padding: '10px' }}>
        {this.renderUploadInputs()}

        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', marginTop: '10px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.refs.msoCreateInputRefOriginal.click();
            }}
          >
            <Translate value="original" />
          </Button>
          <span style={{ width: '50px' }} />
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.refs.msoCreateInputRef.click();
            }}
          >
            <Translate value="new" />
          </Button>
        </div>
      </form>
    )
  }
}

const formName = 'excelUploadOption';

const selector = formValueSelector(formName);

const ExcelUploadOptionForm = reduxForm({
  // a unique name for the form
  form: formName,
  enableReinitialize: true,
})(form);


const ExcelUploadOption = ({ setModalVisibility, isVisible, onSuccess }) => (
  <SkyLightStateless
    title={'Upload Options'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <ExcelUploadOptionForm
      setModalVisibility={setModalVisibility}
      onSuccess={onSuccess}
    />
  </SkyLightStateless>
)

ExcelUploadOption.propTypes = propTypes;
ExcelUploadOption.defaultProps = defaultProps;

const mapState = (state) => {
  return ({
    date: selector(state, 'date'),
  })
}
const mapProps = dispatch => ({
  setFormValue: (field, value) => {
    dispatch(change(formName, field, value));
  }
})
export default connect(mapState, mapProps)(ExcelUploadOption);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/ExcelUploadOption.jsx